import { JuchuDataToArray, JuchuDetailDataToArray } from '../appForms/juchuNyuryoku/ObjectToArray';
import http from '../common/compornents/httpcommon';
import { JuchuData } from '../common/objectType/JuchuData';
import { JuchuDetailData } from '../common/objectType/JuchuDetailData';

class JuchuNyuryokuServ {
  // コンボボックス「納入先」取得処理
  selNonyusakiList = (tokuisakiCode: String, tokuisakiSalesCode: String, juchuBango: String) => {
    var params = { tokCd: tokuisakiCode, tokCd2: tokuisakiSalesCode, jyuNo: juchuBango };
    return http.get('selNonyusakiList/', { params });
  };

  // コンボボックス「ユーザー」取得処理
  selUserList = (tokuisakiCode: String, tokuisakiSalesCode: String) => {
    var params = { tokCd: tokuisakiCode, tokCd2: tokuisakiSalesCode };
    return http.get('selUserList/', { params });
  };

  // コンボボックス「入目」取得処理
  selIrimeListData = (hinmokuCode: String, sizeSeq: String) => {
    var params = { hinCd: hinmokuCode, sizeSeq: sizeSeq };
    return http.get('selIrimeListData/', { params });
  };

  // コンボボックス「入目単位」取得処理
  selIrimeTaniListData = (hinmokuCode: String, irime: String) => {
    var params = { hinCd: hinmokuCode, irime: irime };
    return http.get('selIrimeTaniListData/', { params });
  };

  // コンボボックス「入目単位(MA)」取得処理
  selIrimeTaniMaListData = (hinmokuCode: String, sizeSeq: String, irime: String) => {
    var params = { hinCd: hinmokuCode, sizeSeq: sizeSeq, irime: irime };
    return http.get('selIrimeTaniMaListData/', { params });
  };

  // コンボボックス「数量単位」取得処理
  selNisugataKbnListData = (
    hinmokuCode: String,
    irime: String,
    irimeTani: String,
    sizeSeq: String
  ) => {
    var params = { hinCd: hinmokuCode, irime: irime, irimeTani: irimeTani, sizeSeq: sizeSeq };
    return http.get('selNisugataKbnListData/', { params });
  };

  // コンボボックス「艶」取得処理
  selTuyaListData = (hinmokuCode: String) => {
    var params = { hinCd: hinmokuCode };
    return http.get('selTuyaListData/', { params });
  };

  // コンボボックス「サイズ」取得処理
  selSizeListData = (hinmokuCode: String) => {
    var params = { hinCd: hinmokuCode };
    return http.get('selSizeListData/', { params });
  };

  // コンボボックス「形状」取得処理
  selHinShapeListData = (hinmokuCode: String) => {
    var params = { hinCd: hinmokuCode };
    return http.get('selHinShapeListData/', { params });
  };

  // コンボボックス「目地」取得処理
  selHinJointListData = (hinmokuCode: String) => {
    var params = { hinCd: hinmokuCode };
    return http.get('selHinJointListData/', { params });
  };

  // コンボボックス「基本色調」取得処理
  selKihonIroCdListData = (irogCd: String) => {
    var params = { irogCd: irogCd };
    return http.get('selKihonIroCdListData/', { params });
  };

  // コンボボックス「運送便」取得処理
  selUnsoListData = (hinmokuCode: String, kenCode: String) => {
    var params = { hinCd: hinmokuCode, kenCd: kenCode };
    return http.get('selUnsoListData/', { params });
  };

  // 有効得意先マスタ検索処理
  selYukoTokuisaki = (tokuisakiCode: String, tokuisakiSalesCode: String) => {
    var params = { tokCd: tokuisakiCode, tokCd2: tokuisakiSalesCode };
    return http.get('selYukoTokuisaki/', { params });
  };

  // 有効納入先マスタ検索処理
  selYukoNonyusaki = (tokuisakiCode: String, tokuisakiSalesCode: String, seq: number) => {
    var params = { tokCd: tokuisakiCode, tokCd2: tokuisakiSalesCode, seq: seq };
    return http.get('selYukoNonyusaki/', { params });
  };

  // 製品情報検索処理
  selHinmokuData = (tokuisakiCode: String, tokuisakiSalesCode: String, hinmokuCode: String) => {
    var params = { tokCd: tokuisakiCode, tokCd2: tokuisakiSalesCode, hinCd: hinmokuCode };
    return http.get('selHinmokuData/', { params });
  };

  // 受注検索処理
  selJuchuData = (juchuBango: String) => {
    var params = { jyuNo: juchuBango };
    return http.get('selJuchuData/', { params });
  };

  // 受注明細検索処理
  selJuchuListData = (tokCd: string, tokcd2: string, juchuBango: string) => {
    var params = { tokCd: tokCd, tokCd2: tokcd2, jyuNo: juchuBango };
    return http.get('selJuchuListData/', { params });
  };

  // 工事管理番号検索処理
  selKojiNo = (kojiNo: String, tokuisakiCode: String, tokuisakiSalesCode: String) => {
    var params = { kojiNo: kojiNo, tokCd: tokuisakiCode, tokCd2: tokuisakiSalesCode };
    return http.get('selKojiNo/', { params });
  };

  // 回答納期検索処理
  selKaitoNoki = (
    tokuisakiCode: String,
    tokuisakiSalesCode: String,
    hinmokuCode: String,
    kenCode: String,
    siCode: String,
    haiCode: String,
    haiCode2: String
  ) => {
    var params = {
      tokCd: tokuisakiCode,
      tokCd2: tokuisakiSalesCode,
      hinCd: hinmokuCode,
      kenCd: kenCode,
      cityCd: siCode,
      haiCd: haiCode,
      haiCd2: haiCode2,
    };
    return http.get('selKaitoNoki/', { params });
  };

  // 回答納期検索処理
  selUnsoBin = (
    tokuisakiCode: String,
    tokuisakiSalesCode: String,
    hinmokuCode: String,
    kenCode: String,
    siCode: String
  ) => {
    var params = {
      tokCd: tokuisakiCode,
      tokCd2: tokuisakiSalesCode,
      hinCd: hinmokuCode,
      kenCd: kenCode,
      cityCd: siCode,
    };
    return http.get('selUnsoBin/', { params });
  };

  // 追跡用URL検索処理
  selhaiUrl = (haiCd: string, haiCd2: string) => {
    var params = { haiCd: haiCd, haiCd2: haiCd2 };
    return http.get('selhaiUrl/', { params });
  };

  // 製品存在チェック
  checkHinmokuData = (tokuisakiCode: String, tokuisakiSalesCode: String, hinmokuCode: String) => {
    var params = { tokCd: tokuisakiCode, tokCd2: tokuisakiSalesCode, hinCd: hinmokuCode };
    return http.get('checkHinmokuData/', { params });
  };

  // セットバラシ処理
  clickSetBarashi = (
    tokCd: String,
    tokCd2: String,
    juchuDetail: JuchuDetailData
  ) => {

    // var lsjuchuDetail = JuchuDetailDataToArray(tokuisakiCode, tokuisakiSalesCode, param);
    return http.post('clickSetBarashi/', { tokCd, tokCd2, juchuDetail });
  };

  // 確定処理
  clickKakutei = (
    jishaKbn: String,
    shoriSentaku: String,
    companyCd: String,
    accountId: String,
    tokuisakiCode: String,
    tokuisakiSalesCode: String,
    juchuHeader: JuchuData,
    JuchuDetailData: JuchuDetailData[],
    lsDeleteData: any[],
    headerData: JuchuData
  ) => {
    juchuHeader = { ...juchuHeader, ...headerData };
    var juchu = JuchuDataToArray(jishaKbn, shoriSentaku, companyCd, accountId, juchuHeader);
    var lsjuchuDetail = JuchuDetailDataToArray(tokuisakiCode, tokuisakiSalesCode, JuchuDetailData);

    return http.post('clickKakutei/', { juchu, lsjuchuDetail, lsDeleteData });
  };

  // 確定後処理
  clickKakuteiAto = (
    jishaKbn: String,
    shoriSentaku: String,
    companyCd: String,
    accountId: String,
    tokuisakiCode: String,
    tokuisakiSalesCode: String,
    juchuHeader: JuchuData,
    JuchuDetailData: JuchuDetailData[],
    resData: any,
    tanNm: String
  ) => {
    var juchu = JuchuDataToArray(jishaKbn, shoriSentaku, companyCd, accountId, juchuHeader);
    var lsjuchuDetail = JuchuDetailDataToArray(tokuisakiCode, tokuisakiSalesCode, JuchuDetailData);

    return http.post('clickKakuteiAto/', { juchu, lsjuchuDetail, resData, tanNm });
  };

  // アカウントデータ検索処理
  selAccountData = (compnyCd: String, accountId: String) => {
    var params = { compnyCd: compnyCd, accountId: accountId };
    return http.get('selAccountData/', { params });
  };
}
export default new JuchuNyuryokuServ();
